export default "__VITE_ASSET__DfPOBMeh__"